/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
async function applyStealthScripts(page) {
    await page.setBypassCSP(true);
    await page.setUserAgent("Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/237.84.2.178 Safari/537.36");
    await page.evaluate(()=>{
        Object.defineProperty(navigator, 'webdriver', {
            get: ()=>void 0
        });
        Object.defineProperty(navigator, 'languages', {
            get: ()=>[
                    'en-US',
                    'en'
                ]
        });
        Object.defineProperty(navigator, 'plugins', {
            get: ()=>[
                    {},
                    {},
                    {},
                    {},
                    {}
                ]
        });
        Object.defineProperty(navigator, 'headless', {
            get: ()=>false
        });
        const originalQuery = window.navigator.permissions.query;
        window.navigator.permissions.query = (parameters)=>'notifications' === parameters.name ? Promise.resolve({
                state: Notification.permission
            }) : originalQuery(parameters);
    });
}
function getSearchPageLinks(window1) {
    const links = [];
    const document = window1.document;
    const isValidUrl = (url)=>{
        try {
            new URL(url);
            return true;
        } catch (error) {
            return false;
        }
    };
    try {
        const elements = document.querySelectorAll('.g');
        elements.forEach((element)=>{
            const titleEl = element.querySelector('h3');
            const urlEl = element.querySelector('a');
            const url = null == urlEl ? void 0 : urlEl.getAttribute('href');
            if (!url || !isValidUrl(url)) return;
            const item = {
                title: (null == titleEl ? void 0 : titleEl.textContent) || '',
                url,
                snippet: '',
                content: ''
            };
            if (!item.title || !item.url) return;
            links.push(item);
        });
    } catch (error) {
        console.error(error);
    }
    return links;
}
async function interceptRequest(page) {
    await applyStealthScripts(page);
    await page.setRequestInterception(true);
    page.on('request', (request)=>{
        const resourceType = request.resourceType();
        if ('document' !== resourceType) return request.abort();
        if (request.isNavigationRequest()) return request.continue();
        return request.abort();
    });
}
export { applyStealthScripts, getSearchPageLinks, interceptRequest };

//# sourceMappingURL=misc.mjs.map